module.exports = __webpack_public_path__ + "static/media/concierge-bg.25bf2dbd.mp4";